import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Icon from '../../../assets/images/png/list-refused.png';
import { Avatar, Button, Modal } from 'antd';
import i18n from 'i18next';
import { GlobalModalHandler, GlobalModalClose } from '../../layout/GlobalModal';

import { getOrderState } from '../../../store/orders/selector';
import { getCooks } from '../../../store/orders/actions';

import { Orders } from '../../../store/orders/types';
import { ProfileReportHandler } from '../../userprofile/ProfileReport';

interface AcceptOrderProps {
  meal: Orders;
  navigate: Function;
}

export const OrderRefused = ({ meal, navigate }: AcceptOrderProps) => {
  const { userinfo } = useSelector(getOrderState);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCooks(meal.cook));
  }, [dispatch, meal.cook]);

  const handleReportButton = () => {
    const reports = {
      reportedby: meal.userdetails.id,
      user: userinfo.id,
      type: userinfo.type,
    };
    Modal.destroyAll();
    ProfileReportHandler({ reports });
  };

  const handleContinueButton = () => {
    GlobalModalClose();
    navigate();
  };

  return (
    <div className="modal-content-wrapper">
      <div className="modal-content-icon margin-top">
        <img src={Icon} alt="modal-content-icon" />
      </div>
      <div className="modal-content-description">
        <span>{i18n.t('REFUSE_MESSAGE')}</span>
        <div className="cook-details">
          <div>
            <Avatar src={userinfo.image} />
            <span>{userinfo.firstName}</span>
          </div>
        </div>
        <div className="modal-content-extra-text margin-top">
          {meal.refusedmessage}
        </div>
      </div>
      <div className="button-container margin-top ">
        <Button
          block
          type="primary"
          shape="round"
          className="continue-button continue-button-primary"
          onClick={handleContinueButton}
        >
          <span className="continue-button-text">{i18n.t('Continue')}</span>
        </Button>
        <Button
          block
          shape="round"
          className="cancel-button cancel-button-primary"
          onClick={handleReportButton}
        >
          <span className="continue-button-text">{i18n.t('Report Cook')}</span>
        </Button>
      </div>
    </div>
  );
};

export const OrderRefuseModalHandler = (
  meal: Orders,
  navigate: (e?: React.MouseEvent) => void
) => {
  GlobalModalHandler({
    content: <OrderRefused meal={meal} navigate={navigate} />,
  });
};
